/*
 * @Descripttion:
 * @FilePath: /azg/src/views/download/store/axt/config.js
 * @Author: 张兴业
 * @Date: 2021-11-16 18:26:18
 * @LastEditors: hl
 * @LastEditTime: 2024-11-25 11:05:35
 */
import { $G } from "@/global";
const AxtConfig = {
  logo: $G(
    "https://assets-img.myazstore.com/website/images/download/axt/logo_title.png"
  ),
  bg: $G(
    "https://assets-img.myazstore.com/website/images/download/commons/bg.png"
  ),
  brand: $G(
    "https://assets-img.myazstore.com/website/images/download/axt/brand.png"
  ),
  // app_title1: "az",
  // app_title2: "澳新通",
  hint_content: "*请微信扫码以下APP进行登入使用",
  ios_qrcode: $G(
    "https://assets-img.myazstore.com/website/images/download/axt/app_qrcode_ios.png"
  ),
  android_qrcode: $G(
    "https://assets-img.myazstore.com/website/images/download/axt/app_qrcode_android.png"
  ),
  ios_btn: $G(
    "https://assets-img.myazstore.com/website/images/download/commons/ios_btn.png"
  ),
  android_btn: $G(
    "https://assets-img.myazstore.com/website/images/download/commons/android_btn.png"
  ),
  ios_link: $G("itms-apps://itunes.apple.com/app/1590793270"),
  android_link: $G("https://assets-apk.myazstore.com/app/axt-android.apk"),
};

export default AxtConfig;
